import {
  useState,
  useRef,
  useCallback,
  useEffect
} from "react";

export const useResizablePanel = () => {

  const [rightPanelWidth, setRightPanelWidth] =
    useState(30);

  const containerRef = useRef(null);

  const isResizing = useRef(false);

  const resize = useCallback((e) => {
    if (
      !isResizing.current ||
      !containerRef.current
    )
      return;

    const containerRect =
      containerRef.current.getBoundingClientRect();

    const newLeftWidth =
      e.clientX - containerRect.left;

    const containerWidth =
      containerRect.width;

    let newRightWidthPercent =
      100 - (newLeftWidth / containerWidth) * 100;

    if (newRightWidthPercent < 30)
      newRightWidthPercent = 30;

    if (newRightWidthPercent > 70)
      newRightWidthPercent = 70;

    setRightPanelWidth(newRightWidthPercent);
  }, []);

  const stopResizing = useCallback(() => {
    isResizing.current = false;

    document.removeEventListener(
      "mousemove",
      resize
    );

    document.removeEventListener(
      "mouseup",
      stopResizing
    );

    document
      .querySelectorAll("iframe")
      .forEach(
        (iframe) =>
          (iframe.style.pointerEvents = "auto")
      );
  }, [resize]);

  const startResizing = useCallback(() => {
    isResizing.current = true;

    document.addEventListener(
      "mousemove",
      resize
    );

    document.addEventListener(
      "mouseup",
      stopResizing
    );

    document
      .querySelectorAll("iframe")
      .forEach(
        (iframe) =>
          (iframe.style.pointerEvents = "none")
      );
  }, [resize, stopResizing]);

  useEffect(() => {
    return () => {
      document.removeEventListener(
        "mousemove",
        resize
      );

      document.removeEventListener(
        "mouseup",
        stopResizing
      );
    };
  }, [resize, stopResizing]);

  return {
    rightPanelWidth,
    containerRef,
    startResizing
  };
};